// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/volume/v1/volume.proto (package chalk.volume.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/volume/v1/volume.proto.
 */
export const file_chalk_volume_v1_volume: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_flags_v1_flags, file_google_protobuf_timestamp]);

/**
 * VolumeInfo describes a named volume.
 *
 * @generated from message chalk.volume.v1.VolumeInfo
 */
export type VolumeInfo = Message<"chalk.volume.v1.VolumeInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.volume.v1.VolumeInfo.
 * Use `create(VolumeInfoSchema)` to create a new message.
 */
export const VolumeInfoSchema: GenMessage<VolumeInfo> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 0);

/**
 * FileInfo describes a single file inside a volume.
 *
 * @generated from message chalk.volume.v1.FileInfo
 */
export type FileInfo = Message<"chalk.volume.v1.FileInfo"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: int64 size = 2;
   */
  size: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message chalk.volume.v1.FileInfo.
 * Use `create(FileInfoSchema)` to create a new message.
 */
export const FileInfoSchema: GenMessage<FileInfo> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 1);

/**
 * @generated from message chalk.volume.v1.CreateVolumeRequest
 */
export type CreateVolumeRequest = Message<"chalk.volume.v1.CreateVolumeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.volume.v1.CreateVolumeRequest.
 * Use `create(CreateVolumeRequestSchema)` to create a new message.
 */
export const CreateVolumeRequestSchema: GenMessage<CreateVolumeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 2);

/**
 * @generated from message chalk.volume.v1.CreateVolumeResponse
 */
export type CreateVolumeResponse = Message<"chalk.volume.v1.CreateVolumeResponse"> & {
  /**
   * @generated from field: chalk.volume.v1.VolumeInfo volume = 1;
   */
  volume?: VolumeInfo;
};

/**
 * Describes the message chalk.volume.v1.CreateVolumeResponse.
 * Use `create(CreateVolumeResponseSchema)` to create a new message.
 */
export const CreateVolumeResponseSchema: GenMessage<CreateVolumeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 3);

/**
 * @generated from message chalk.volume.v1.GetVolumeRequest
 */
export type GetVolumeRequest = Message<"chalk.volume.v1.GetVolumeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.volume.v1.GetVolumeRequest.
 * Use `create(GetVolumeRequestSchema)` to create a new message.
 */
export const GetVolumeRequestSchema: GenMessage<GetVolumeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 4);

/**
 * @generated from message chalk.volume.v1.GetVolumeResponse
 */
export type GetVolumeResponse = Message<"chalk.volume.v1.GetVolumeResponse"> & {
  /**
   * @generated from field: chalk.volume.v1.VolumeInfo volume = 1;
   */
  volume?: VolumeInfo;
};

/**
 * Describes the message chalk.volume.v1.GetVolumeResponse.
 * Use `create(GetVolumeResponseSchema)` to create a new message.
 */
export const GetVolumeResponseSchema: GenMessage<GetVolumeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 5);

/**
 * @generated from message chalk.volume.v1.ListVolumesRequest
 */
export type ListVolumesRequest = Message<"chalk.volume.v1.ListVolumesRequest"> & {
  /**
   * Maximum number of volumes to return. Defaults to 100 if unset or zero.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Pagination token returned from a previous ListVolumes call.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message chalk.volume.v1.ListVolumesRequest.
 * Use `create(ListVolumesRequestSchema)` to create a new message.
 */
export const ListVolumesRequestSchema: GenMessage<ListVolumesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 6);

/**
 * @generated from message chalk.volume.v1.ListVolumesResponse
 */
export type ListVolumesResponse = Message<"chalk.volume.v1.ListVolumesResponse"> & {
  /**
   * @generated from field: repeated chalk.volume.v1.VolumeInfo volumes = 1;
   */
  volumes: VolumeInfo[];

  /**
   * Token to pass into the next ListVolumes call to get the next page.
   * Empty when there are no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message chalk.volume.v1.ListVolumesResponse.
 * Use `create(ListVolumesResponseSchema)` to create a new message.
 */
export const ListVolumesResponseSchema: GenMessage<ListVolumesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 7);

/**
 * @generated from message chalk.volume.v1.DeleteVolumeRequest
 */
export type DeleteVolumeRequest = Message<"chalk.volume.v1.DeleteVolumeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message chalk.volume.v1.DeleteVolumeRequest.
 * Use `create(DeleteVolumeRequestSchema)` to create a new message.
 */
export const DeleteVolumeRequestSchema: GenMessage<DeleteVolumeRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 8);

/**
 * @generated from message chalk.volume.v1.DeleteVolumeResponse
 */
export type DeleteVolumeResponse = Message<"chalk.volume.v1.DeleteVolumeResponse"> & {
};

/**
 * Describes the message chalk.volume.v1.DeleteVolumeResponse.
 * Use `create(DeleteVolumeResponseSchema)` to create a new message.
 */
export const DeleteVolumeResponseSchema: GenMessage<DeleteVolumeResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 9);

/**
 * @generated from message chalk.volume.v1.ListFilesRequest
 */
export type ListFilesRequest = Message<"chalk.volume.v1.ListFilesRequest"> & {
  /**
   * @generated from field: string volume_name = 1;
   */
  volumeName: string;

  /**
   * @generated from field: string prefix = 2;
   */
  prefix: string;
};

/**
 * Describes the message chalk.volume.v1.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema: GenMessage<ListFilesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 10);

/**
 * @generated from message chalk.volume.v1.ListFilesResponse
 */
export type ListFilesResponse = Message<"chalk.volume.v1.ListFilesResponse"> & {
  /**
   * @generated from field: repeated chalk.volume.v1.FileInfo files = 1;
   */
  files: FileInfo[];
};

/**
 * Describes the message chalk.volume.v1.ListFilesResponse.
 * Use `create(ListFilesResponseSchema)` to create a new message.
 */
export const ListFilesResponseSchema: GenMessage<ListFilesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 11);

/**
 * @generated from message chalk.volume.v1.GetFileRequest
 */
export type GetFileRequest = Message<"chalk.volume.v1.GetFileRequest"> & {
  /**
   * @generated from field: string volume_name = 1;
   */
  volumeName: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * When true, return a pre-signed URL instead of inline bytes.
   *
   * @generated from field: optional bool get_signed_uri = 3;
   */
  getSignedUri?: boolean;
};

/**
 * Describes the message chalk.volume.v1.GetFileRequest.
 * Use `create(GetFileRequestSchema)` to create a new message.
 */
export const GetFileRequestSchema: GenMessage<GetFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 12);

/**
 * @generated from message chalk.volume.v1.GetFileResponse
 */
export type GetFileResponse = Message<"chalk.volume.v1.GetFileResponse"> & {
  /**
   * @generated from oneof chalk.volume.v1.GetFileResponse.content
   */
  content: {
    /**
     * The file data returned inline.
     *
     * @generated from field: bytes data = 1;
     */
    value: Uint8Array;
    case: "data";
  } | {
    /**
     * A pre-signed URL the caller can use to download the file directly.
     *
     * @generated from field: string signed_download_uri = 2;
     */
    value: string;
    case: "signedDownloadUri";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.volume.v1.GetFileResponse.
 * Use `create(GetFileResponseSchema)` to create a new message.
 */
export const GetFileResponseSchema: GenMessage<GetFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 13);

/**
 * @generated from message chalk.volume.v1.PutFileRequest
 */
export type PutFileRequest = Message<"chalk.volume.v1.PutFileRequest"> & {
  /**
   * @generated from field: string volume_name = 1;
   */
  volumeName: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from oneof chalk.volume.v1.PutFileRequest.content
   */
  content: {
    /**
     * The file data to upload inline.
     *
     * @generated from field: bytes data = 3;
     */
    value: Uint8Array;
    case: "data";
  } | {
    /**
     * An identifier referencing a blob already stored in object storage.
     *
     * @generated from field: string storage_object_id = 4;
     */
    value: string;
    case: "storageObjectId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.volume.v1.PutFileRequest.
 * Use `create(PutFileRequestSchema)` to create a new message.
 */
export const PutFileRequestSchema: GenMessage<PutFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 14);

/**
 * @generated from message chalk.volume.v1.PutFileResponse
 */
export type PutFileResponse = Message<"chalk.volume.v1.PutFileResponse"> & {
};

/**
 * Describes the message chalk.volume.v1.PutFileResponse.
 * Use `create(PutFileResponseSchema)` to create a new message.
 */
export const PutFileResponseSchema: GenMessage<PutFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 15);

/**
 * @generated from message chalk.volume.v1.RemoveFileRequest
 */
export type RemoveFileRequest = Message<"chalk.volume.v1.RemoveFileRequest"> & {
  /**
   * @generated from field: string volume_name = 1;
   */
  volumeName: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;
};

/**
 * Describes the message chalk.volume.v1.RemoveFileRequest.
 * Use `create(RemoveFileRequestSchema)` to create a new message.
 */
export const RemoveFileRequestSchema: GenMessage<RemoveFileRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 16);

/**
 * @generated from message chalk.volume.v1.RemoveFileResponse
 */
export type RemoveFileResponse = Message<"chalk.volume.v1.RemoveFileResponse"> & {
};

/**
 * Describes the message chalk.volume.v1.RemoveFileResponse.
 * Use `create(RemoveFileResponseSchema)` to create a new message.
 */
export const RemoveFileResponseSchema: GenMessage<RemoveFileResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 17);

/**
 * @generated from message chalk.volume.v1.GetObjectUploadUriRequest
 */
export type GetObjectUploadUriRequest = Message<"chalk.volume.v1.GetObjectUploadUriRequest"> & {
  /**
   * Total size of the content in bytes.
   *
   * @generated from field: int64 content_size = 1;
   */
  contentSize: bigint;

  /**
   * Hash of the content (e.g. SHA-256) for integrity verification.
   *
   * @generated from field: string hash = 2;
   */
  hash: string;

  /**
   * Desired part size for multipart upload. The server may adjust this.
   *
   * @generated from field: int64 part_size = 3;
   */
  partSize: bigint;
};

/**
 * Describes the message chalk.volume.v1.GetObjectUploadUriRequest.
 * Use `create(GetObjectUploadUriRequestSchema)` to create a new message.
 */
export const GetObjectUploadUriRequestSchema: GenMessage<GetObjectUploadUriRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 18);

/**
 * S3-style multipart upload: N part URIs plus a completion URI.
 *
 * @generated from message chalk.volume.v1.MultipartUpload
 */
export type MultipartUpload = Message<"chalk.volume.v1.MultipartUpload"> & {
  /**
   * Pre-signed URIs for each part, ordered by part number.
   * The last URI is a completion URI that must be called only
   * after all preceding part uploads have finished successfully.
   *
   * @generated from field: repeated string signed_upload_uris = 1;
   */
  signedUploadUris: string[];
};

/**
 * Describes the message chalk.volume.v1.MultipartUpload.
 * Use `create(MultipartUploadSchema)` to create a new message.
 */
export const MultipartUploadSchema: GenMessage<MultipartUpload> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 19);

/**
 * GCS-style resumable upload: single session URI with chunked PUT.
 *
 * @generated from message chalk.volume.v1.ResumableUpload
 */
export type ResumableUpload = Message<"chalk.volume.v1.ResumableUpload"> & {
  /**
   * A resumable session URI. The caller uploads data via chunked
   * PUT requests with Content-Range headers.
   *
   * @generated from field: string signed_upload_uri = 1;
   */
  signedUploadUri: string;
};

/**
 * Describes the message chalk.volume.v1.ResumableUpload.
 * Use `create(ResumableUploadSchema)` to create a new message.
 */
export const ResumableUploadSchema: GenMessage<ResumableUpload> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 20);

/**
 * Azure block blob upload: one SAS-authenticated blob URL used for block staging
 * and final commit.
 *
 * @generated from message chalk.volume.v1.AzureBlockUpload
 */
export type AzureBlockUpload = Message<"chalk.volume.v1.AzureBlockUpload"> & {
  /**
   * Blob URL with SAS query params. The caller stages blocks against this blob
   * with comp=block and commits with comp=blocklist.
   *
   * @generated from field: string signed_blob_uri = 1;
   */
  signedBlobUri: string;

  /**
   * Stable prefix used by the caller to derive deterministic block IDs for
   * resumable uploads.
   *
   * @generated from field: string block_id_prefix = 2;
   */
  blockIdPrefix: string;

  /**
   * Optional advisory block size in bytes. Zero means the caller may choose.
   *
   * @generated from field: int64 part_size = 3;
   */
  partSize: bigint;
};

/**
 * Describes the message chalk.volume.v1.AzureBlockUpload.
 * Use `create(AzureBlockUploadSchema)` to create a new message.
 */
export const AzureBlockUploadSchema: GenMessage<AzureBlockUpload> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 21);

/**
 * Single-shot upload: one signed URL the caller PUTs the entire object to.
 * Used when the server has signed a plain PUT URL (e.g. S3 PutObject, GCS
 * PUT, Azure PutBlob) rather than orchestrating multipart, GCS resumable, or
 * Azure block staging. Subject to the underlying cloud's single-request size
 * limits (S3 PutObject: 5 GiB).
 *
 * @generated from message chalk.volume.v1.DirectUpload
 */
export type DirectUpload = Message<"chalk.volume.v1.DirectUpload"> & {
  /**
   * @generated from field: string signed_upload_uri = 1;
   */
  signedUploadUri: string;
};

/**
 * Describes the message chalk.volume.v1.DirectUpload.
 * Use `create(DirectUploadSchema)` to create a new message.
 */
export const DirectUploadSchema: GenMessage<DirectUpload> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 22);

/**
 * @generated from message chalk.volume.v1.GetObjectUploadUriResponse
 */
export type GetObjectUploadUriResponse = Message<"chalk.volume.v1.GetObjectUploadUriResponse"> & {
  /**
   * The storage object identifier to reference once upload is complete.
   *
   * @generated from field: string storage_object_id = 1;
   */
  storageObjectId: string;

  /**
   * @generated from oneof chalk.volume.v1.GetObjectUploadUriResponse.upload
   */
  upload: {
    /**
     * @generated from field: chalk.volume.v1.MultipartUpload multipart = 2;
     */
    value: MultipartUpload;
    case: "multipart";
  } | {
    /**
     * @generated from field: chalk.volume.v1.ResumableUpload resumable = 3;
     */
    value: ResumableUpload;
    case: "resumable";
  } | {
    /**
     * @generated from field: chalk.volume.v1.AzureBlockUpload azure_block = 4;
     */
    value: AzureBlockUpload;
    case: "azureBlock";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.volume.v1.GetObjectUploadUriResponse.
 * Use `create(GetObjectUploadUriResponseSchema)` to create a new message.
 */
export const GetObjectUploadUriResponseSchema: GenMessage<GetObjectUploadUriResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 23);

/**
 * @generated from message chalk.volume.v1.GetObjectDownloadUriRequest
 */
export type GetObjectDownloadUriRequest = Message<"chalk.volume.v1.GetObjectDownloadUriRequest"> & {
  /**
   * @generated from field: string storage_object_id = 1;
   */
  storageObjectId: string;
};

/**
 * Describes the message chalk.volume.v1.GetObjectDownloadUriRequest.
 * Use `create(GetObjectDownloadUriRequestSchema)` to create a new message.
 */
export const GetObjectDownloadUriRequestSchema: GenMessage<GetObjectDownloadUriRequest> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 24);

/**
 * @generated from message chalk.volume.v1.GetObjectDownloadUriResponse
 */
export type GetObjectDownloadUriResponse = Message<"chalk.volume.v1.GetObjectDownloadUriResponse"> & {
  /**
   * @generated from field: string signed_download_uri = 1;
   */
  signedDownloadUri: string;
};

/**
 * Describes the message chalk.volume.v1.GetObjectDownloadUriResponse.
 * Use `create(GetObjectDownloadUriResponseSchema)` to create a new message.
 */
export const GetObjectDownloadUriResponseSchema: GenMessage<GetObjectDownloadUriResponse> = /*@__PURE__*/
  messageDesc(file_chalk_volume_v1_volume, 25);

/**
 * DataPlaneObjectStorageService provides pre-signed URIs for direct object storage access.
 *
 * @generated from service chalk.volume.v1.DataPlaneObjectStorageService
 */
export const DataPlaneObjectStorageService: GenService<{
  /**
   * @generated from rpc chalk.volume.v1.DataPlaneObjectStorageService.GetObjectUploadUri
   */
  getObjectUploadUri: {
    methodKind: "unary";
    input: typeof GetObjectUploadUriRequestSchema;
    output: typeof GetObjectUploadUriResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.DataPlaneObjectStorageService.GetObjectDownloadUri
   */
  getObjectDownloadUri: {
    methodKind: "unary";
    input: typeof GetObjectDownloadUriRequestSchema;
    output: typeof GetObjectDownloadUriResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_volume_v1_volume, 0);

/**
 * VolumeService manages persistent named volumes backed by object storage.
 *
 * @generated from service chalk.volume.v1.VolumeService
 */
export const VolumeService: GenService<{
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.CreateVolume
   */
  createVolume: {
    methodKind: "unary";
    input: typeof CreateVolumeRequestSchema;
    output: typeof CreateVolumeResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.GetVolume
   */
  getVolume: {
    methodKind: "unary";
    input: typeof GetVolumeRequestSchema;
    output: typeof GetVolumeResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.ListVolumes
   */
  listVolumes: {
    methodKind: "unary";
    input: typeof ListVolumesRequestSchema;
    output: typeof ListVolumesResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.DeleteVolume
   */
  deleteVolume: {
    methodKind: "unary";
    input: typeof DeleteVolumeRequestSchema;
    output: typeof DeleteVolumeResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.ListFiles
   */
  listFiles: {
    methodKind: "unary";
    input: typeof ListFilesRequestSchema;
    output: typeof ListFilesResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.GetFile
   */
  getFile: {
    methodKind: "unary";
    input: typeof GetFileRequestSchema;
    output: typeof GetFileResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.PutFile
   */
  putFile: {
    methodKind: "unary";
    input: typeof PutFileRequestSchema;
    output: typeof PutFileResponseSchema;
  },
  /**
   * @generated from rpc chalk.volume.v1.VolumeService.RemoveFile
   */
  removeFile: {
    methodKind: "unary";
    input: typeof RemoveFileRequestSchema;
    output: typeof RemoveFileResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_volume_v1_volume, 1);

